export default __webpack_public_path__ + "static/purchase_to_process-1ed4cbfd52d7570113512cb08b6811ed.png";